import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import { useItemsPaginator } from 'app_hooks/useItemsPaginator/useItemsPaginator'
import React, { FC, ReactNode, useMemo } from 'react'

import './TableItemsPaginator.scss'

export enum ItemsPaginationAlign {
  START = 'flex-start',
  CENTER = 'center',
  END = 'flex-end',
}

interface ITableItemsPaginatorProps {
  items: any[]
  perPage: number
  children: (itemsToRender: any) => ReactNode
  alignPagination?: ItemsPaginationAlign
}

const TableItemsPaginator: FC<ITableItemsPaginatorProps> = ({
  items,
  perPage,
  children,
  alignPagination,
}) => {
  const { itemsToRender, handleChangePage, currentPage, totalPages } = useItemsPaginator({ items, perPage })

  const pages = useMemo(() => {
    let response: number[] = []
    for (let idx = 0; idx < totalPages ; idx++) {
      response.push(idx+1)
    }
    return response
  }, [totalPages])

  return (
    <div className="table-items-paginator--layout">
      {children(itemsToRender)}
      {totalPages > 1 && (
        <div
          className="table-items-paginator--paginator"
          style={{ justifyContent: alignPagination }}
        >
          <TextComponent
            className={`${currentPage <= 1 ? 'table-items-paginator--disabled' : ''}`}
            onClick={currentPage <= 1 ? undefined : () => handleChangePage(currentPage - 1)}
          >
            Anterior
          </TextComponent>
          {pages.map((page) => (
            <TextComponent
              key={page}
              className={`${currentPage === page ? 'table-items-paginator--current' : ''}`}
              onClick={() => handleChangePage(page)}
            >
              {page}
            </TextComponent>
          ))}
          <TextComponent
            className={`${currentPage >= totalPages ? 'table-items-paginator--disabled' : ''}`}
            onClick={currentPage >= totalPages ? undefined : () => handleChangePage(currentPage + 1)}
          >
            Siguiente
          </TextComponent>
        </div>
      )}
    </div>
  )
}

export default TableItemsPaginator
